import React from 'react';
import Translation from '@s/Translation';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';
import { setCheckoutOverlay } from '../../../actions/ui';
import Button from '../../../../shared/Button';

export const ContinueShoppingButton = ({ buttonClass }) => {
  const dispatch = useDispatch();

  const onClick = () => {
    dispatch(setCheckoutOverlay(false));
  }

  return (
    <Button
        className={classNames("button--large", buttonClass ?? "button--clear")}
        onClick={onClick}
    >
        <Translation>{'checkout__add_more_tickets'}</Translation>
    </Button>
  )
}